export default {
    config: {
        apiKey: "AIzaSyBoO4KBCfzP_IHYBoU-8tZEEFtwEYW5rfk",
        authDomain: "supermercado-del-pueblo.firebaseapp.com",
        databaseURL: "https://supermercado-del-pueblo.firebaseio.com",
        projectId: "supermercado-del-pueblo",
        storageBucket: "supermercado-del-pueblo.appspot.com",
        messagingSenderId: "83861541250",
        appId: "1:83861541250:web:d9814e70b090c6aa497f9b",
        measurementId: "G-MYXQG4DPDK"
    }
}